export const cityCoords = {
    '上海': [121.472644, 31.231706],
    '杭州': [120.153576, 30.287459],
    '株洲': [113.133853, 27.827986],
    '长沙': [112.982279, 28.19409],
    '香港': [114.173355, 22.320048],
    '北京': [116.405285, 39.904989],
    '深圳': [114.085947, 22.547],
    '广州': [113.280637, 23.125178],
    '成都': [104.065735, 30.659462],
    '重庆': [106.501556, 29.587089],
    '西安': [108.948024, 34.263161],
    '武汉': [114.315252, 30.592765],
    '南京': [118.767413, 32.041544],
    '天津': [117.190182, 39.125596],
    '沈阳': [123.43277, 41.805712],
    '青岛': [120.382639, 36.067139],
    '济南': [116.994979, 36.671108],
    '郑州': [113.665412, 34.757975],
    '贵阳': [106.713478, 26.578343],
    '昆明': [102.712251, 25.040609],
    '南宁': [108.320004, 22.82402],
    '海口': [110.33119, 20.031971],
    '三亚': [109.501262, 18.247872],
    '拉萨': [91.117527, 29.646912],
    '西宁': [101.778916, 36.623178],
    '兰州': [103.823557, 36.058039],
    '银川': [106.278179, 38.46637],
    '乌鲁木齐': [87.617733, 43.792818],
    '呼和浩特': [111.670801, 40.818311],
    '哈尔滨': [126.642464, 45.756967],
    '长春': [125.3245, 43.886841], 
    '大连': [121.618622, 38.91459],
    '鞍山': [122.995632, 41.110626],
    '抚顺': [123.921506, 41.875956],
    '本溪': [123.766412, 41.297909],
    '丹东': [124.383044, 40.124296],
    '邵阳': [111.46923, 27.237842],
    '常德': [111.691347, 29.04025],
    '张家界': [110.479921, 29.117096],
    '益阳': [112.355042, 28.570066],
    '郴州': [113.032067, 25.793589],
    '永州': [111.62544, 26.223608],
    '怀化': [109.97824, 27.550082],
    '娄底': [112.008416, 27.728136],
    '湘西': [109.739735, 28.314296], 
    '浏阳': [113.643122, 28.161731],
  }